import { Component, ViewEncapsulation } from '@angular/core';
import { Popover } from 'primeng/popover';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { Constants } from '../../_utility/';
import { AuthService } from '../../_services';
import { LanguagePickerComponent } from '../language-picker/language-picker.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [Popover, ButtonModule, LanguagePickerComponent],
})
export class HeaderComponent {
  constructor(private router: Router, public auth: AuthService) {}

  goTo(path: string) {
    switch (path) {
      case 'home': {
        this.router.navigate(Constants.Routing.HOME.routerLink);
        break;
      }
    }
  }

  SingOut() {
    this.auth.SignOut();
  }
}
